import { render, staticRenderFns } from "./betting.vue?vue&type=template&id=12813b0a&"
import script from "./betting.vue?vue&type=script&lang=js&"
export * from "./betting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports